/* eslint-disable import/prefer-default-export */

import { gql } from "@apollo/client";

export const IQAC_DATAS = gql`
  query Query($filterInput: FilterIQACInput!) {
    getIQACDatas(filterInput: $filterInput) {
      totalCount
      Iqacs {
        member_name
        id
        type
        createdBy
        criteria_type
        createdAt
        status
        user {
          id
          name
          username
        }
      }
    }
  }
`;

export const GET_CRITERIAS = gql`
  query GetCriterias {
    getCriterias {
      id
      criteria_name
      file_url
    }
  }
`;

export const GET_ACTIVITIES = gql`
  query GetActivities($activityFilter: ActivityFilterInput!) {
    getActivities(activityFilter: $activityFilter) {
      totalCount
      club {
        id
        title
        description
        vedio_link
        status
        ActivityImages {
          id
          img_link
        }
      }
    }
  }
`;
